module.exports = __webpack_public_path__ + "img/c3.00473cd8.png";